<template>
  <div id="index">
    <div class="head">
      <head-box></head-box>
    </div>
    <div class="bottom">
      <div class="isComponents">
        <router-view />
      </div>
      <div class="bottom-box">
        <bottom-box></bottom-box>
      </div>
    </div>
    <login></login>

    <el-dialog center :show-close="false" width="468px" title="绑定微信公众号" :visible.sync="bindWeChat">
      <img style="display: flex;margin: 0 auto" :src="bindWxQR">
    </el-dialog>



    <!-- 隐私政策弹窗 -->
    <el-dialog
        custom-class="custom-dialog"
        width="900"
        append-to-body
        title="隐私协议"
        :visible.sync="dialogVisible">
      <div class="mz">
        <el-scrollbar style="height: 575px;padding-bottom: 0px">
          <div class="privacy-content">
            <p>
              欢迎您访问我们的产品。泓庚航海在线练习（包括网站等产品提供的服务，以下简称“产品和服务”）是由厦门泓庚航海科技有限公司（以下简称“我们”）开发并运营的。确保用户的数据安全和隐私保护是我们的首要任务，本隐私政策载明了您访问和使用我们的产品和服务时所收集的数据及其处理方式。</p>

            <p>
              请您在继续使用我们的产品前务必认真仔细阅读并确认充分理解本隐私政策全部规则和要点，一旦您选择使用，即视为您同意本隐私政策的全部内容，同意我们按其收集和使用您的相关信息。如您在阅读过程中，对本政策有任何疑问，可联系我们的客服咨询，请通过
              18005020034@163.com
              或产品中的反馈方式与我们取得联系。如您不同意相关协议或其中的任何条款的，您应停止使用我们的产品和服务。</p>

            <p>本隐私政策帮助您了解以下内容：</p>
            <p>一、定义；</p>
            <p>二、我们如何收集和使用您的个人信息；</p>
            <p>三、我们如何存储和保护您的个人信息；</p>
            <p>四、我们如何共享、转让、公开披露您的个人信息；</p>
            <p>五、本政策如何更新；</p>
            <p>六、如何联系我们；</p>

            <h3>一、定义</h3>
            <p>我们：指厦门泓庚航海科技有限公司。</p>
            <p>个人信息：指以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息，不包括匿名化处理后的信息。</p>
            <p>
              个人敏感信息：指一旦泄露或者非法使用，可能导致个人受到歧视或者人身、财产受到严重危害的个人信息，包括种族、民族、宗教信仰、个人生物特征、医疗健康、金融账户、个人行踪等信息（我们将在本隐私政策中对具体个人敏感信息以粗体进行显著标识）。</p>
            <p>未成年人：指不满18周岁的自然人。</p>
            <p>儿童：指不满14周岁的自然人。</p>

            <h3>二、我们如何收集和使用您的个人信息</h3>
            <p>个人信息是指以电子或者其他方式记录的能够单独或者与其他信息，结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。我们根据《中华人民共和国网络安全法》和《信息安全技术个人信息安全规范》（GB/T
              35273-2017）以及其它相关法律法规的要求，并严格遵循正当、合法、必要的原则，出于您使用我们提供的服务和/或产品等过程中而收集和使用您的个人信息，包括但不限于电话号码、电子邮箱地址等。</p>
            <p>
              为接受我们全面的产品服务，您应首先注册一个用户账号，我们将通过它记录相关的数据。您所提供的所有信息均来自于您本人在注册时提供的数据。您准备使用的账户名、密码、您本人的联系方式，我们可能通过发短信或者邮件的方式来验证您的身份是否有效。</p>

            <h3>三、我们如何存储和保护您的个人信息</h3>
            <p>
              作为一般规则，我们仅在实现信息收集目的所需的时间内保留您的个人信息。我们会在对于管理与您之间的关系严格必要的时间内保留您的个人信息（例如，当您开立帐户，从我们的产品获取服务时）。出于遵守法律义务或为证明某项权利或合同满足适用的诉讼时效要求的目的，我们可能需要在上述期限到期后保留您存档的个人信息，并且无法按您的要求删除。当您的个人信息对于我们的法定义务或法定时效对应的目的或档案不再必要时，我们确保将其完全删除或匿名化。</p>
            <p>
              我们使用符合业界标准的安全防护措施保护您提供的个人信息，并加密其中的关键数据，防止其遭到未经授权访问、公开披露、使用、修改、损坏或丢失。我们会采取一切合理可行的措施，保护您的个人信息。我们会使用加密技术确保数据的保密性；我们会使用受信赖的保护机制防止数据遭到恶意攻击。</p>

            <h3>四、我们如何共享、转让、公开披露您的个人信息</h3>
            <p>
              在管理我们的日常业务活动所需要时，为追求合法利益以更好地服务客户，我们将合规且恰当的使用您的个人信息。出于对业务和各个方面的综合考虑，我们仅自身使用这些数据，不与任何第三方分享。</p>
            <p>
              我们可能会根据法律法规规定，或按政府主管部门的强制性要求，对外共享您的个人信息。在符合法律法规的前提下，当我们收到上述披露信息的请求时，我们会要求必须出具与之相应的法律文件，如传票或调查函。我们坚信，对于要求我们提供的信息，应该在法律允许的范围内尽可能保持透明。</p>

            <p>在以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：</p>
            <p>1、与国家安全、国防安全直接相关的；</p>
            <p>2、与犯罪侦查、起诉、审判和判决执行等直接相关的；</p>
            <p>3、出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>
            <p>4、您自行向社会公众公开的个人信息；</p>
            <p>5、从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</p>
            <p>6、根据个人信息主体要求签订和履行合同所必需的；</p>
            <p>7、用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；</p>
            <p>8、法律法规规定的其他情形。</p>

            <h3>五、本政策如何更新</h3>
            <p>我们的隐私政策可能变更。</p>
            <p>未经您明确同意，我们不会削减您在本政策项下应享有的权利。我们会在本页面上发布对本政策所作的任何变更。</p>
            <p>
              对于重大变更，我们还会提供更为显著的通知（比如官方公告、推送通知、发送短信或者电子邮件），并在本政策更新后您首次登陆时再次获取您的明示同意。若您在本政策更新且接到我们的通知后，点击同意或下一步，这表示您已充分阅读、理解并接受修订后的本政策。</p>

            <p>本政策所指的重大变更包括但不限于：</p>
            <p>1、我们的服务模式发生重大变化，比如处理个人信息的类型、目的和方式等；</p>
            <p>2、我们在所有权结构、组织架构等方面发生重大变化，比如业务调整、并购、破产等引起的所有者变更等；</p>
            <p>3、个人信息共享、转让或者公开披露的主要对象发生变化；</p>
            <p>4、您参与个人信息处理方面的权利及其行使方式发生重大变化；</p>
            <p>5、我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；</p>
            <p>6、个人信息安全影响评估报告表明存在高风险时。</p>
            <p>我们还会将本政策的旧版本存档，供您查阅。</p>

            <h3>六、如何联系我们</h3>
            <p>1.如果您对本政策有任何疑问、意见或建议，可通过以下方式与我们联系：</p>
            <p>（1）拨打客服热线电话 0592-6226339</p>
            <p>（2）发送电子邮件至：18005020034@163.com</p>
            <p>（3）联系地址：福建省厦门市火炬高新区软件园三期溪山尾路67号801，联系人：谭女士</p>
            <p>我们的客服部门将会同个人信息保护部门30天内进行回复，并协助解决您的问题。</p>
            <p>
              2.如果您对我们的回复不满意，特别是我们的个人信息处理行为损害了您的合法权益，您还可以通过以下外部途径寻求解决方式：向厦门泓庚航海科技有限公司所在地人民法院提起诉讼，或向网信、工商、公安等监管部门进行投诉或举报。</p>
          </div>

        </el-scrollbar>
      </div>

    </el-dialog>
    <el-dialog
      title="云课堂用户支付协议"
      :visible.sync="global.isAgree"
      custom-class="custom-dialog"
      width="900"
      append-to-body
    >
    <div class="mz">
        <el-scrollbar style="height: 575px;padding-bottom: 0px">
      <!-- 协议内容区域（带滚动条） -->
      <div class="privacy-content">
          <!-- <p>云课堂用户支付协议</p> -->
          <p>甲方（服务提供方）：厦门泓庚航海科技有限公司</p>
          <p>乙方（付费用户）：使用甲方云课堂服务的注册用户</p>
          <p>本协议由甲乙双方在平等、自愿、公平、诚实信用的原则下，就乙方购买甲方云课堂平台付费课程、会员及其他增值服务等相关支付事宜，达成如下协议，以资共同遵守。</p>
      

      <h3>第一条 服务与购买</h3>
      <p>1. 甲方通过其运营的云课堂平台，向乙方提供在线课程、会员权限、学习资料等付费服务。</p>
      <p>2. 乙方自愿在本平台选择并购买付费服务，确认所购服务内容、价格、有效期、使用规则等信息，并同意按照本协议及平台公示规则支付费用。</p>
      <p>3. 乙方承诺所提供的支付信息、身份信息真实有效，因信息不实导致的支付失败、服务异常等后果由乙方自行承担。</p>

      <h3>第二条 支付规则</h3>
      <p>1. 乙方可通过本平台支持的支付方式（包括但不限于微信支付、支付宝、银行卡支付等）完成费用支付。</p>
      <p>2. 乙方支付成功后，甲方将按照订单约定为乙方开通对应付费服务，服务开通后不可随意变更、更换课程。</p>  
      <p>3. 本平台所有标注价格均为人民币计价，如遇平台活动、优惠折扣、套餐定价等，以乙方下单时实际支付金额为准。</p>
      <p>4. 因银行、第三方支付机构产生的手续费、汇率差异等费用，由乙方自行承担。</p>

      <h3>第四条 课程内容</h3>
      <p>1. 乙方支付成功后，除法律法规规定及本协议另有约定外，不支持无理由退款。乙方购买前应充分了解课程内容、服务形式、有效期等信息，谨慎下单。</p>
      <p>2. 符合以下情形的，乙方可向甲方申请退款，甲方审核通过后按实际情况处理：</p>  
        <p>（1）乙方未完成课程学习，且课程未结束。</p>
        <p>（2）法律法规规定应当退款的其他情形。</p>
      <p>3. 存在以下情形的，不予退款：</p>  
        <p>（1）乙方已观看、学习课程内容（含试看、完整观看）；</p>
        <p>（2）乙方账号已激活会员、课程权限，且已实际使用；</p>
        <p>（3）因乙方个人原因（误购、放弃学习、设备问题、不再需要等）申请退款；</p>
        <p>（4）乙方违反平台协议、违规使用服务、账号被封禁等。</p>
      <p>4. 退款申请流程：乙方通过平台客服渠道提交申请及证明材料，甲方在7个工作日内审核并反馈结果；退款原路返回至乙方支付账户，到账时间以第三方支付机构/银行规则为准。</p>

      <h3>第四条 服务使用</h3>
      <p>1. 乙方付费后获得的课程、会员等服务，仅限本人账号使用，不得转让、出借、售卖、共享、转播，否则甲方有权终止服务、封禁账号，不予退款。</p>
      <p>2. 付费服务均设有使用有效期，乙方应在有效期内完成学习与使用，逾期自动失效，甲方不予延期、不予退款。</p>
      <p>3. 甲方有权对平台服务进行升级、优化，如课程内容更新，不影响乙方已购服务的正常使用。</p>

      <h3>第五条 权利与义务</h3>
      <p>（一）甲方权利义务</p>
      <p>1. 按照订单约定向乙方提供对应的付费服务，保障服务正常运行。</p>
      <p>2. 保护乙方支付信息与个人信息安全，不得非法泄露、使用。</p>
      <p>3. 对恶意下单、违规支付、盗号消费等行为，有权拒绝提供服务、冻结账号并追究法律责任。</p>

      <p>（二）乙方权利义务</p>
      <p>1. 按照约定支付费用，获得对应付费服务使用权。</p>
      <p>2. 妥善保管账号与密码，因乙方保管不当导致账号被盗、消费异常等，由乙方自行承担责任。</p>
      <p>3. 不得利用付费服务进行侵权、盗版、传播、商业牟利等违法违规行为。</p>

      <h3>第六条 免责条款</h3>
      <p>1. 因不可抗力（政府管制、网络故障、第三方支付故障、自然灾害等）导致支付失败、服务中断的，双方互不承担违约责任。</p>
      <p>2. 因第三方支付机构系统问题导致的扣款异常、延迟到账，甲方协助核查，但不承担直接赔偿责任。</p>

      <h3>第七条 争议解决</h3>
      <p>1. 本协议的签订、履行、解释及争议解决均适用中华人民共和国法律。</p>
      <p>2. 双方因本协议产生争议，应先友好协商解决；协商不成的，任何一方均有权向甲方所在地（厦门市）有管辖权的人民法院提起诉讼。</p>

      <h3>第八条 其他</h3>
      <p>1. 本平台公示的订单页面、支付页面、退款规则、用户协议均为本协议不可分割的组成部分。</p>
      <p>2. 甲方有权根据业务需要修订本协议，修订后将在平台公示，公示后生效；乙方继续使用服务视为同意修订内容。</p>
      <p>3. 本协议自乙方完成支付之日起生效。</p>

      <p>厦门泓庚航海科技有限公司</p>
      </div>
      </el-scrollbar>
      </div>

      <!-- 弹窗底部按钮 -->
      <!-- <div slot="footer" class="dialog-footer">
        <el-button @click="global.isAgree = false">关闭</el-button>
        <el-button type="primary" @click="agreeAgreement">我已阅读并同意</el-button>
      </div> -->
    </el-dialog>
  </div>
</template>
<script>
import * as req from "@/utils/request";
import headBox from '@/components/head.vue'
import bottomBox from '@/components/bottom.vue'
import login from '@/views/login.vue'
import netty from "@/utils/websocket";
import {setToken} from "@/utils/token/jwtService";
export default {
  name: 'AdaptiveComponent',
  components: {
    headBox,
    bottomBox,
    login
  },
  data() {
    return {
      bindWeChat: false,
      bindWxQR: null,
    }
  },
  watch: {
  },
  created() {
    this.getUserInfo()
  },
  computed: {
    dialogVisible: {
      get() {
        return window.$global.dialogVisible
      },
      set(val) {
        window.$global.dialogVisible = val
      }
    },
  },
  methods: {
    // 获取用户信息
    getUserInfo() {
      let sendData = {}
      sendData.data = null
      sendData.fn = this.getUserInfoFn
      sendData.vm = this
      req.Get('sysUser/getUserInfo', sendData)
    },
    getUserInfoFn(data) {
      if (!data) return
      if (data.code !== 200) {
        window.localStorage.removeItem("Authorization")
        window.$global.userDetails = null
        return;
      }
      // this.queryProductList()
      if (data.code === 200) {
        window.$global.user = data.data
        let user = data.data.sysUser
        // 是否需要绑定微信公众号
        if (!user.openid) {
          this.bindWx(user)
        }
        // 教师给予学生的权限
        // let authorities = data.data.authorities
        // if (authorities) {
        //   this.$message.error(JSON.stringify(authorities))
        // }
        // 学生充值产品的有效期
        let productExpired = data.data.productExpired

        if (!productExpired) {
          productExpired = []
        }
        let addKey = {}
        for (let row of productExpired) {
           row.courses.forEach((course) => {
             addKey[course.id] = course
           })
        }
        data.data.productExpired = addKey
        window.$global.userDetails = data.data
      }
    },
    // 首次登录 需要绑定微信
    bindWx(user) {
      let sendData = {}
      sendData.data = user
      sendData.fn = this._bindWxFn
      sendData.vm = this
      req.Post('wechat/qr/concern', sendData)
    },
    _bindWxFn(data) {
      if (data.code !== 200) {
        // this.$message.error(data.message)
        console.error(data.message)
        return
      }
      // todo代码优化 需要判空
      let userId = window.$global.userDetails.sysUser.id
      this.bindWeChat = true
      this.bindWxQR = data.data.qrBase64
      this.ws = new netty(userId)
          .createWebSocket((data) => {
            this.bindWeChat = false
            this.bindWxQR = null
            this.$message.success("绑定成功, 下次可用于扫码登录！")
            this.ws.closeNetty()
          })

    },
  }
}
</script>

<style scoped >
#index {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}
.head {
  height: 15vh;
}
.bottom {
  height: calc(100vh - 15vh);
  width: 100vw;
  overflow: hidden;
  overflow-y: auto;
}
.isComponents {
  /* height: calc(100% - 20vh); */
  /* border-bottom: 1px solid black; */
}
.bottom-box {
  height: 18vh;
  /* border: 1px solid black; */
}



.mz {
  font-family: Arial, sans-serif;
  text-align: left;
  border-radius: 6px;
}

.mz h1 {
  font-size: 20px;
  margin-bottom: 10px;
}

.mz h2 {
  font-size: 18px;
  margin-bottom: 8px;
}

.mz p {
  margin-bottom: 6px;
}

/deep/ .el-scrollbar .el-scrollbar__wrap {
  overflow-x: hidden;
}

>>> .el-dialog {
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: calc(100% - 150px);
  max-width: calc(100% - 30px);
  border-radius: 12px;
}

>>> .el-dialog .el-dialog__body {
  flex: 1;
  overflow: hidden;
}

>>> .el-dialog .el-dialog__header {
  font-size: 0.12rem;
}
</style>